// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": false,
    "raw": "f9e94dee",
    "hash": "f9e94dee",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "f9e94dee",
    "semverString": null,
    "timestamp": 1742581335740,
    "dateStr": "Fri Mar 21 2025 18:22:15 GMT+0000 (Coordinated Universal Time)"
};
/* tslint:enable */
